import { render, staticRenderFns } from "./Characterization.vue?vue&type=template&id=45273976"
import script from "./Characterization.vue?vue&type=script&lang=js"
export * from "./Characterization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports